import { render, staticRenderFns } from "./homeDepositar.vue?vue&type=template&id=3972d900"
import script from "./homeDepositar.vue?vue&type=script&lang=ts"
export * from "./homeDepositar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports